import { Currency } from '@/graphql/generated/types.generated';

export const currencySymbol = (
    value?: number | null,
    currency?: Pick<Currency, 'symbol'> | null,
    fixedDecimals?: number,
) => {
    const formatted = fixedDecimals !== undefined ? (value || 0).toFixed(fixedDecimals) : String(value || 0);
    return currency?.symbol.replace('%default%', formatted) || '';
};
